'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SheetsRegistry = exports.SheetsRegistryProvider = exports.jss = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.create = create;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jss = require('jss');

var _jssPresetDefault = require('jss-preset-default');

var _jssPresetDefault2 = _interopRequireDefault(_jssPresetDefault);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _SheetsRegistryProvider = require('./SheetsRegistryProvider');

var _SheetsRegistryProvider2 = _interopRequireDefault(_SheetsRegistryProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var refNs = 'ref-' + String(Math.random()).substr(2);
var refs = function refs(sheet) {
  return sheet[refNs] || 0;
};
var dec = function dec(sheet) {
  return --sheet[refNs];
};
var inc = function inc(sheet) {
  return ++sheet[refNs];
};

/**
 * Wrap a Component into a JSS Container Component.
 *
 * @param {Jss} jss
 * @param {Component} WrappedComponent
 * @param {Object} stylesOrSheet
 * @param {Object} [options]
 * @return {Component}
 */
function wrap(jss, WrappedComponent, stylesOrSheet) {
  var _class, _temp;

  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var sheet = null;
  var styles = stylesOrSheet;

  // Accept StyleSheet instance.
  if (stylesOrSheet && typeof stylesOrSheet.attach === 'function') {
    sheet = stylesOrSheet;
    styles = null;
  }

  var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

  if (!options.meta) options.meta = displayName;

  function ref() {
    if (!sheet) sheet = jss.createStyleSheet(styles, options);
    if (sheet[refNs] === undefined) sheet[refNs] = 0;
    if (refs(sheet) === 0) sheet.attach();
    inc(sheet);
    return sheet;
  }

  function deref() {
    if (dec(sheet) === 0) sheet.detach();
  }

  return _temp = _class = function (_Component) {
    _inherits(Jss, _Component);

    function Jss() {
      _classCallCheck(this, Jss);

      return _possibleConstructorReturn(this, (Jss.__proto__ || Object.getPrototypeOf(Jss)).apply(this, arguments));
    }

    _createClass(Jss, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.sheet = ref();
        var jssSheetsRegistry = this.context.jssSheetsRegistry;

        if (jssSheetsRegistry) jssSheetsRegistry.add(this.sheet);
      }
    }, {
      key: 'componentWillUpdate',
      value: function componentWillUpdate() {
        if (process.env.NODE_ENV !== 'production') {
          // Support React Hot Loader.
          if (this.sheet !== sheet) {
            this.sheet.detach();
            this.sheet = ref();
          }
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.sheet && !sheet) {
          this.sheet.detach();
          var jssSheetsRegistry = this.context.jssSheetsRegistry;

          if (jssSheetsRegistry) jssSheetsRegistry.remove(this.sheet);
        } else deref();
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2['default'].createElement(WrappedComponent, _extends({ sheet: this.sheet }, this.props));
      }
    }]);

    return Jss;
  }(_react.Component), _class.wrapped = WrappedComponent, _class.displayName = 'Jss(' + displayName + ')', _class.contextTypes = {
    jssSheetsRegistry: _react.PropTypes.instanceOf(_jss.SheetsRegistry)
  }, _temp;
}

var Container = function Container(_ref) {
  var children = _ref.children;
  return children || null;
};

var jss = exports.jss = (0, _jss.create)((0, _jssPresetDefault2['default'])());

// Global index counter to preserve source order.
// As we create the style sheet during componentWillMount lifecycle,
// children are handled after the parents, so the order of style elements would
// be parent->child. It is a problem though when a parent passes a className
// which needs to override any childs styles. StyleSheet of the child has a higher
// specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -100000;

/**
 * Create a `injectSheet` function that will use the passed JSS instance.
 *
 * @param {Jss} jss
 * @return {Function}
 * @api public
 */
function create() {
  var localJss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : jss;

  return function injectSheet(stylesOrSheet) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (options.index === undefined) {
      options.index = indexCounter++;
    }
    return function () {
      var WrappedComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Container;

      var Jss = wrap(localJss, WrappedComponent, stylesOrSheet, options);
      return (0, _hoistNonReactStatics2['default'])(Jss, WrappedComponent, { wrapped: true });
    };
  };
}

/**
 * Exports injectSheet function as default.
 * Returns a function which needs to be invoked with a Component.
 *
 * `injectSheet(styles, [options])(Component)`
 *
 * @param {Object} styles
 * @param {Object} [options]
 * @return {Function}
 * @api public
 */
exports['default'] = create();
exports.SheetsRegistryProvider = _SheetsRegistryProvider2['default'];
exports.SheetsRegistry = _jss.SheetsRegistry;


//////////////////
// WEBPACK FOOTER
// ./~/react-jss/lib/index.js
// module id = 42
// module chunks = 0